// extracted by mini-css-extract-plugin
module.exports = {"footer":"StrrrmFooter_footer__3dt5P","button":"StrrrmFooter_button__2uXJP"};